import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import request from './common/request';
import _ from "lodash";

// import "../public/serviceWorker";
navigator.serviceWorker.register('/serviceWorker.js')


request.getJson5('config.json5').then(resp => {
  const config = resp.data;
  return Promise.all(_.map(config.additiveConfigPaths, path => request.getJson5(path)
    .then(resp => resp.data))).
      then(results => {
        return _.merge(config, ...results);
  }).then(config => {

    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
    );

    const configJson: any = config;
    const handlerClass = require(`./handler/${config.handlers}`).default;
    const handler: any = new handlerClass();
    root.render(
      // <React.StrictMode>
        <App 
          config={configJson}
          handler={handler} 
        />
      // </React.StrictMode>
    );
  }).catch(err => {
    console.error(err.stack);
  });
})

if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/serviceWorker.js")
            .then((registration) => {
                console.log("ServiceWorker registered: ", registration);
            })
            .catch((error) => {
                console.error("ServiceWorker registration failed: ", error);
            });
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
